export { getDynamicContentfulHeading } from './getDynamicContentfulHeading';
export { getDynamicContentfulReferenceActions } from './getDynamicContentfulReferenceActions';
export { getDynamicValueDependingOnUser } from './getDynamicValueDependingOnUser';
export { getDynamicContentfulSubheading } from './getDynamicContentfulSubheading';
export { getDynamicContentfulHero } from './getDynamicContentfulHero';
export { contentfulImageLoader } from './contentfulImageLoader';
export { getContentfulAssetImageProps } from './getContentfulAssetImageProps';
export { getContentfulImageProps } from './getContentfulImageProps';
export { getPersonFullName } from './getPersonFullName';
export { getTemplatePageProps } from './getTemplatePageProps';
export { getTemplateProps } from './getTemplateProps';
export { mergeDeep } from './mergeDeep';
